/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/style-prop-object */
import React, {useEffect, useState} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../_metronic/helpers'
import {useAuth} from '../../modules/auth/core/Auth'
import {ResetPasswordModal} from '../dashboard/_modals/Futurisk/ResetPasswordModal'
import toast, {Toaster} from 'react-hot-toast'
import PhoneModel from './DashboardPhoneModel'
import {NomineeModal} from '../../modules/futurisk/Nominee/Nominee'

const DashboardMiniHeader: React.FC = () => {
  const {currentUser} = useAuth()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [modalShow, setModalShow] = useState(false)
  const [editingPhone, setEditingPhone] = useState(false)
  const [newPhone, setNewPhone] = useState('')
  const [otp, setOtp] = useState('')
  const [otpSent, setOtpSent] = useState(false)
  const [loading, setLoading] = useState(false)
  const isPhoneValid = /^\d{10}$/.test(newPhone)
  const isOtpValid = /^\d{6}$/.test(otp)
  const isDefaultPasswordNotify = !!currentUser?.IsDefaultPasswordNotify

  useEffect(() => {
    // show default-password notification once when the user flag is true
    if (isDefaultPasswordNotify) {
      toast.error('Please change the Default Password')
    }
    // only re-run when this specific flag changes
  }, [isDefaultPasswordNotify])

  return (
    <div
      className='card shadow mb-5 mb-xl-5 bgi-no-repeat'
      style={{
        backgroundPosition: 'right top',
        backgroundSize: '30% auto',
        backgroundImage: `url(${toAbsoluteUrl('/media/svg/shapes/abstract-1.svg')})`,
      }}
    >
      <div className='card-body pt-2 pb-2'>
        <Toaster />
        <div className='d-flex  flex-wrap flex-sm-nowrap'>
          {currentUser?.LogoUrl === undefined && (
            <div className='symbol symbol-100px symbol-lg-160px symbol-fixed position-relative d-none d-lg-block'>
              <img src={toAbsoluteUrl('/media/futuriskicon/ms-icon-150x150.png')} alt='Futurisk' />
            </div>
          )}
          {currentUser?.LogoUrl !== undefined && (
            <div
              className='col-xl-2 me-7 bgi-no-repeat d-none d-lg-block'
              style={{
                backgroundPosition: 'center center',
                backgroundSize: 'contain',
                backgroundImage: `url(${currentUser?.LogoUrl})`,
                minHeight: '80px',
              }}
            ></div>
          )}

          <div className='flex-grow-1'>
            <div className='d-flex justify-content-between align-items-start flex-wrap pt-4'>
              <div className='d-flex flex-column'>
                <div className='d-flex align-items-center mb-2'>
                  <a
                    className='text-black text-hover-primary fs-2 fw-bolder me-1'
                    style={{textTransform: 'capitalize'}}
                  >
                    {currentUser?.Name.toLocaleLowerCase()}
                  </a>

                  <KTSVG
                    path={
                      currentUser?.IsHR
                        ? '/media/icons/duotune/general/gen0260.svg'
                        : '/media/icons/duotune/general/gen026.svg'
                    }
                    className='svg-icon-1 svg-icon-primary'
                  />
                </div>

                <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2'>
                  <a className='d-flex align-items-center text-black text-hover-primary me-5 mb-2'>
                    <KTSVG
                      path='/media/icons/duotune/communication/com013.svg'
                      className='svg-icon-4 me-1'
                    />
                    {currentUser?.EmployeeId}
                  </a>

                  <a className='d-flex align-items-center text-black text-hover-primary me-5 mb-2'>
                    <KTSVG
                      path='/media/icons/duotune/communication/com011.svg'
                      className='svg-icon-4 me-1'
                    />
                    {currentUser?.Email}
                  </a>

                  <a className='d-flex align-items-center text-black text-hover-primary me-5 mb-2 '>
                    <KTSVG
                      path='/media/icons/duotune/communication/com005.svg'
                      className='svg-icon-4 me-1'
                    />
                    {currentUser?.PhoneNumber ? (
                      // When phone exists make it clickable to update
                      <button
                        type='button'
                        className='btn btn-link p-0 text-black'
                        onClick={() => {
                          setEditingPhone(true)
                          // normalize to digits only when editing
                          setNewPhone(
                            (currentUser?.PhoneNumber || '').replace(/\D/g, '').slice(0, 10)
                          )
                          setOtp('')
                          setOtpSent(false)
                        }}
                        aria-label='Edit phone number'
                      >
                        {currentUser?.PhoneNumber}
                      </button>
                    ) : (
                      // when empty, show explicit update call-to-action
                      <button
                        type='button'
                        className='btn btn-link btn-sm ms-2 p-0 text-black'
                        onClick={() => {
                          setEditingPhone(true)
                          setNewPhone('')
                          setOtp('')
                          setOtpSent(false)
                        }}
                      >
                        Update Phone Number
                      </button>
                    )}
                  </a>
                  {editingPhone && (
                    <div className='card p-3 w-100 mt-2'>
                      <div className='mb-2'>
                        <label className='form-label'>New Phone</label>
                        <input
                          className='form-control form-control-sm'
                          value={newPhone}
                          onChange={(e) => {
                            // allow digits only, limit to 10
                            const digits = e.target.value.replace(/\D/g, '')
                            setNewPhone(digits.slice(0, 10))
                          }}
                          placeholder='Enter new phone number (10 digits)'
                        />
                        {newPhone && !isPhoneValid && (
                          <div className='text-danger small mt-1'>
                            Phone must be exactly 10 digits.
                          </div>
                        )}
                      </div>

                      {!otpSent && (
                        <div className='d-flex gap-2'>
                          <button
                            className='btn btn-primary btn-sm'
                            disabled={loading || !isPhoneValid}
                            onClick={async () => {
                              try {
                                setLoading(true)
                                await PhoneModel.sendOtpForPhoneUpdate(newPhone, {
                                  CRMClientId: currentUser?.CRMClientId,
                                  EmployeeId: currentUser?.EmployeeId,
                                })
                                toast.success('OTP sent in Email')
                                setOtpSent(true)
                              } catch (err: any) {
                                console.error(err)
                                toast.error(err?.message || 'Failed to send OTP')
                              } finally {
                                setLoading(false)
                              }
                            }}
                          >
                            Send OTP
                          </button>

                          <button
                            className='btn btn-secondary btn-sm'
                            onClick={() => setEditingPhone(false)}
                          >
                            Cancel
                          </button>
                        </div>
                      )}

                      {otpSent && (
                        <div className='mt-2'>
                          <label className='form-label'>Enter OTP</label>
                          <div className='d-flex gap-2'>
                            <input
                              className='form-control form-control-sm'
                              value={otp}
                              onChange={(e) => {
                                const digits = e.target.value.replace(/\D/g, '')
                                setOtp(digits.slice(0, 6))
                              }}
                              placeholder='6-digit Email OTP'
                            />
                            <button
                              className='btn btn-success btn-sm'
                              disabled={loading || !isOtpValid}
                              onClick={async () => {
                                try {
                                  setLoading(true)
                                  const res = await PhoneModel.submitOtpForPhoneUpdate(
                                    newPhone,
                                    otp,
                                    {
                                      CRMClientId: currentUser?.CRMClientId,
                                      EmployeeId: currentUser?.EmployeeId,
                                    }
                                  )

                                  // API returns { status: 'otpwrong' } or { status: 'updated' }
                                  if (res && res.status === 'otpwrong') {
                                    toast.error('Invalid OTP — please re-enter')
                                    setOtp('')
                                    // keep otpSent true so user can retry
                                  } else if (res && res.status === 'updated') {
                                    toast.success('Phone Number updated')
                                    // refresh page upon success
                                    window.location.reload()
                                  } else {
                                    // fallback: treat as success if no explicit status
                                    toast.success('Phone Number updated')
                                    window.location.reload()
                                  }
                                } catch (err: any) {
                                  console.error(err)
                                  toast.error(err?.message || 'Failed to verify OTP')
                                } finally {
                                  setLoading(false)
                                }
                              }}
                            >
                              Verify & Update
                            </button>
                          </div>
                          {otp && !isOtpValid && (
                            <div className='text-danger small mt-1'>
                              OTP must be exactly 6 digits.
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </div>

                <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2'>
                  <a className='d-flex align-items-center text-black text-hover-primary me-5 mb-2'>
                    <KTSVG
                      path='/media/icons/duotune/communication/com006.svg'
                      className='svg-icon-4 me-1'
                    />
                    {currentUser?.ClientName}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {Number(currentUser?.CRMClientId) === 910 && currentUser?.IsNomineeAdded === false && (
          <NomineeModal
            show={true}
            handleClose={() => {
              setModalShow(false)
            }}
          />
        )}

        
        {Number(currentUser?.CRMClientId) === 1133 && currentUser?.IsNomineeAdded === false && (
          <NomineeModal
            show={true}
            handleClose={() => {
              setModalShow(false)
            }}
          />
        )}

        {Number(currentUser?.CRMClientId) === 964 && currentUser?.IsNomineeAdded === false && (
          <NomineeModal
            show={true}
            handleClose={() => {
              setModalShow(false)
            }}
          />
        )}

        {currentUser?.IsDefaultPassword && (
          <ResetPasswordModal
            show={currentUser?.IsDefaultPassword}
            handleClose={() => {
              setModalShow(false)
            }}
          />
        )}
      </div>
    </div>
  )
}

export {DashboardMiniHeader}
